var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "session-control-webrtc" },
    [
      _c("div", { staticClass: "session-control-webrtc__media" }, [
        _c("video", {
          attrs: { autoplay: "", muted: "", playsinline: "" },
          domProps: { muted: true },
        }),
        _vm._v(" "),
        _vm.activeSession
          ? _c(
              "div",
              { staticClass: "session-control-webrtc__media__actions_overlay" },
              [
                _c("ui-button", {
                  staticClass: "session-control-webrtc__actions_overlay_button",
                  attrs: {
                    icon:
                      "fal fa-fw " +
                      (_vm.audioMuted
                        ? "fa-microphone-slash"
                        : "fa-microphone"),
                    tooltip:
                      "" + (_vm.audioMuted ? "Unmute audio" : "Mute audio"),
                  },
                  on: { click: _vm.toggleAudioMute },
                }),
                _vm._v(" "),
                _c("ui-button", {
                  staticClass: "session-control-webrtc__actions_overlay_button",
                  attrs: {
                    icon:
                      "fal fa-fw " +
                      (_vm.videoMuted ? "fa-video-slash" : "fa-video"),
                    tooltip:
                      "" + (_vm.videoMuted ? "Unmute video" : "Mute video"),
                  },
                  on: { click: _vm.toggleVideoMute },
                }),
                _vm._v(" "),
                _c("ui-button", {
                  staticClass: "session-control-webrtc__actions_overlay_button",
                  attrs: {
                    tooltip:
                      "" +
                      (_vm.displayMediaStream
                        ? "Stop sharing screen"
                        : "Share screen"),
                  },
                  on: { click: _vm.toggleScreenSharing },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "icon",
                        fn: function () {
                          return [
                            _vm.displayMediaStream
                              ? _c(
                                  "span",
                                  {
                                    staticClass: "fa-stack",
                                    staticStyle: {
                                      "font-size": "18px",
                                      top: "2px",
                                    },
                                  },
                                  [
                                    _c("i", {
                                      staticClass:
                                        "fal fa-desktop fa-stack-1x fa-lg",
                                    }),
                                    _vm._v(" "),
                                    _c("i", {
                                      staticClass:
                                        "fal fa-times fa-stack-1x fa-sm",
                                      staticStyle: { top: "-3px" },
                                    }),
                                  ]
                                )
                              : _c("i", {
                                  staticClass: "fal fa-desktop fa-lg",
                                  staticStyle: {
                                    "font-size": "24px",
                                    "margin-top": "5px",
                                  },
                                }),
                          ]
                        },
                        proxy: true,
                      },
                    ],
                    null,
                    false,
                    4109395627
                  ),
                }),
              ],
              1
            )
          : _vm._e(),
      ]),
      _vm._v(" "),
      !_vm.activeSession
        ? _c(
            "div",
            { staticClass: "session-control-webrtc__controls" },
            [
              _c("ui-button", {
                attrs: {
                  disabled: !_vm.stream || _vm.isConnecting,
                  icon:
                    "fas " +
                    (_vm.isConnecting
                      ? "fa-circle-notch fa-spin"
                      : "fa-circle"),
                  text: _vm.streamId !== null ? "STREAM" : "RECORD",
                  large: "",
                  secondary: "",
                  raised: "",
                },
                on: { click: _vm.startSession },
              }),
              _vm._v(" "),
              _c(
                "ui-select",
                {
                  attrs: { label: "Bandwidth" },
                  model: {
                    value: _vm.selectedBandwidth,
                    callback: function ($$v) {
                      _vm.selectedBandwidth = $$v
                    },
                    expression: "selectedBandwidth",
                  },
                },
                _vm._l(_vm.bandwidths, function (bandwidth) {
                  return _c("ui-select-item", {
                    key: bandwidth.value,
                    attrs: { label: bandwidth.label, value: bandwidth.value },
                    nativeOn: {
                      click: function ($event) {
                        return _vm.setDefaultBandwidth(bandwidth.value)
                      },
                    },
                  })
                }),
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                [
                  _c(
                    "ui-select",
                    {
                      attrs: {
                        disabled: _vm.audioInputs.length === 0,
                        label: "Audio source",
                      },
                      model: {
                        value: _vm.selectedAudioInput,
                        callback: function ($$v) {
                          _vm.selectedAudioInput = $$v
                        },
                        expression: "selectedAudioInput",
                      },
                    },
                    _vm._l(_vm.audioInputs, function (audioInput) {
                      return _c("ui-select-item", {
                        key: audioInput.deviceId,
                        attrs: {
                          label: _vm.removeIdFromDeviceLabel(audioInput.label),
                          value: audioInput.deviceId,
                        },
                        nativeOn: {
                          click: function ($event) {
                            return _vm.setDefaultAudioInput(audioInput.deviceId)
                          },
                        },
                      })
                    }),
                    1
                  ),
                  _vm._v(" "),
                  _vm.stream && _vm.audioInputs.length > 0
                    ? _c("vu-meter", { attrs: { stream: _vm.stream } })
                    : _vm._e(),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "ui-select",
                {
                  attrs: {
                    disabled: _vm.videoInputs.length === 0,
                    label: "Video source",
                  },
                  model: {
                    value: _vm.selectedVideoInput,
                    callback: function ($$v) {
                      _vm.selectedVideoInput = $$v
                    },
                    expression: "selectedVideoInput",
                  },
                },
                _vm._l(_vm.videoInputs, function (videoInput) {
                  return _c("ui-select-item", {
                    key: videoInput.deviceId,
                    attrs: {
                      label: _vm.removeIdFromDeviceLabel(videoInput.label),
                      value: videoInput.deviceId,
                    },
                    nativeOn: {
                      click: function ($event) {
                        return _vm.setDefaultVideoInput(videoInput.deviceId)
                      },
                    },
                  })
                }),
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.activeSession
        ? _c("stream-statistics", {
            attrs: {
              session: _vm.activeSession,
              "stream-title": _vm.streamTitle,
            },
            on: { stop: _vm.stopSession },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }